import React from 'react';
import SelfShopCard from './self-shop-card';
import NormalShopCard from './normal-shop-card';
import './index.scss';

const CompanyCard = props => {
  const { seller } = props;
  const { sellerSelfOperated } = seller;
  if (sellerSelfOperated) {
    return <SelfShopCard {...props} />;
  } else {
    return <NormalShopCard {...props} />;
  }
};

export default CompanyCard;
